const apiURL = "https://be-pronunciation.onrender.com";
export { apiURL };
